import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
interface PriceInfoProps {
  amount: number;
}
export const PriceInfo = t0 => {
  const $ = _c(16);
  const {
    amount
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("flex items-center gap-8 font-700 typo-body1", "tablet:typo-body2", "mobile:typo-body2");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== amount) {
    t2 = amount.toLocaleString();
    $[1] = amount;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <span className="text-Gray-550 line-through">{t2}</span>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="font-600 text-Gray-550 line-through">원 </span>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = <p>{t3}{t4}</p>;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== amount) {
    t6 = amount === 100000 ? <span className="rounded-pill bg-B-25 px-12 py-4 font-700 text-B-500 typo-caption1">10만원 기부 → 모두 세액공제!</span> : null;
    $[8] = amount;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <div className={t1}>{t5}{t6}</div>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="flex items-center gap-8 text-R-500"><span className={cn("flex items-center gap-2 font-700 typo-h3", "tablet:typo-h5", "mobile:typo-h5")}>0원</span><span className={cn("font-400 typo-body3", "tablet:typo-body4", "mobile:typo-body4")}>기부세액 공제 시</span></div>;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t7) {
    t9 = <div>{t7}{t8}</div>;
    $[14] = t7;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
};